import { Id, LaravelResponse, keyToUrl } from "@dgs/core";
import axios from "axios";

const baseKey = ["dashboard", "birthdays"];

export interface BirthdayResource {
	id: Id;
	firstName: string;
	lastName: string;
	dateOfBirth: string;
}

export const birthdayWidgetService = {
	index: (page: number) => {
		return axios.get<LaravelResponse<BirthdayResource[]>>(`${keyToUrl(baseKey)}`, { params: { page } });
	},
	key: baseKey,
};
